/**
 * Base operation controller.
 *
 * Extends an operation controller class.
 *
 * @example
 * import tmrOperationController from 'tmr/controllers/operation/operation';
 * export class MyCustomOperationController extends tmrOperationController {
 *   ...
 * }
 * @type {ngController}
 */
export class tmrOperationController {
  static ngType = 'controller'

  constructor($mdDialog, TmrToast, TmrMovementHelper, TmrOperationHelper) {
    'ngInject'
    Object.assign(this, {
      $mdDialog,
      TmrToast,
      TmrMovementHelper,
      TmrOperationHelper,
    })
  }

  $onInit() {
    this.antenna.$clearEpcs()
    this.initVars()
  }

  $onDestroy() {
    this.antenna.$stop()
  }

  initVars() {
    this.description = ''
    this.detailsPromise = Promise.resolve()
  }

  getConfig(config) {
    return this.TmrOperationHelper.getConfig(config)
  }

  setConfig(config, value) {
    this.TmrOperationHelper.setConfig(config, value)
  }

  onClear() {
    this.antenna.$clearEpcs()
    this.initVars()
  }

  onConfirm() {
    this.confirming = true
    this.antenna.$stop()
  }

  onConfirmed() {
    this.confirming = false
  }

  showItemsByUpcStatusDialog(targetEvent, { upc, epcs, status }) {
    this.$mdDialog.show(
      this.$mdDialog.tmrItemsByUpcStatus({
        targetEvent,
        locals: { upc, epcs, status },
      })
    )
  }
}
